(function() {
    'use strict';

    angular
        .module('szallodak-search-index', []);
})();
